import Backbone from 'backbone';
import $ from 'jquery';
import ko from 'knockout';
import _ from 'underscore';
import csvUtil from '@bingads-webui-component-legacy/js-data-bulk/bulkify';
import {
  RECOMMENDATION_TYPES,
  APPLY_USERINPUT_TYPES,
  formatCampaignBulkApiError,
  CONTEXTUAL_ENTITY_TYPE,
  CAMPAIGN_ODATA_ERROR_BASELINE,
} from '@bingads-webui-campaign/recommendation-core';
import {
  withContextualAttributeTemplate,
  showContextualAttribute,
  hideContextualAttribute,
} from '@bingads-webui-campaign/recommendation-contextual-attribute';
import { HANDLEABLE_ERROR_CODES } from '../const';

import template from '../template/dynamic-search-ads-inline-view.pug';
import ViewModel from '../viewmodel/dynamic-search-ads-inline-view-model';
import EditorsContainer from './editors-container';

export default class DynamicSearchAdsInlineView extends Backbone.View {
  initialize({
    deps = {
      adDisplayUrlService: null,
      combineText: null,
      permissions: {
        IsRecommendationRepairSuggestedAdsEnabled: true,
      },
    },
    data = {},
    i18n,
    isMCC,
    readOnly,
    router,
    gridView,
    gridService,
  }) {
    this.deps = deps;
    this.data = _.first(data.Opportunities);
    this.i18n = i18n;
    this.isMCC = isMCC;
    this.router = router;
    this.readOnly = readOnly;
    this.ko_model = new ViewModel({
      data: this.data,
      i18n: this.i18n,
    });
    this.grid = { gridView };

    this.editorsContainerView = {};
    this.gridService = gridService;
  }

  get events() {
    return {
      'click .btn-hero.apply': 'apply',
      'click .btn-cancel': 'closeInlineView',
      'click .error-message .close': 'dismissMessage',
      'mouseover .recommendation-dynamic-search-ads-inline-view .contextual-tooltip': 'showContextualAttributePopup',
      'mouseout .recommendation-dynamic-search-ads-inline-view .contextual-tooltip': 'hideContextualAttributePopup',
      'click .recommendation-dynamic-search-ads-inline-view .contextual-tooltip': 'scopeRouting',
    };
  }

  scopeRouting(e) {
    this.router(e);
  }

  hideContextualAttributePopup(e) {
    clearTimeout(this.timerForPopupContextualAttribute);
    hideContextualAttribute({ e, self: this });
  }

  showContextualAttributePopup(e) {
    clearTimeout(this.timerForPopupContextualAttribute);
    this.timerForPopupContextualAttribute = setTimeout(() => {
      showContextualAttribute({
        deps: this.deps,
        i18n: this.i18n,
        e,
        type: this.data.OpportunityType,
        isExpanding: true,
        self: this,
        recommendationService: this.gridService.recommendationService,
      });
    }, 500);
  }

  render() {
    const header = this.isMCC ?
      this.i18n.getString(
        'Recommendation_Inline_View_Dynamic_Search_Ads_Header_MCC',
        {
          entity_name: withContextualAttributeTemplate({
            opportunityId: this.data.OpportunityId,
            entityName: this.data.Target.AccountName,
            entityId: this.data.Target.AccountId,
            entityType: CONTEXTUAL_ENTITY_TYPE.ACCOUNT,
            status: 'false',
            isExpandingView: true,
          }),
        }
      ) :
      this.i18n.getString('Recommendation_Inline_View_Dynamic_Search_Ads_Header');
    this.$el.html($(template({ i18n: this.i18n, readOnly: this.readOnly, header })));
    ko.applyBindings(this.ko_model, this.$el[0]);
    this.delegateEvents();

    this.renderEditors(this.ko_model);

    return this;
  }

  dealWithInlineError(errors) {
    this.editorsContainerView
      .dealWithInlineError(formatCampaignBulkApiError(errors, CAMPAIGN_ODATA_ERROR_BASELINE));
  }

  hasInlineError(errors) {
    return !_.isEmpty(_.intersection(
      HANDLEABLE_ERROR_CODES,
      _.map(errors, error => error.ErrorCode)
    ));
  }

  hasChanged() {
    return this.editorsContainerView &&
    this.editorsContainerView.hasChanged &&
    this.editorsContainerView.hasChanged();
  }

  apply() {
    if (!this.editorsContainerView.validate()) {
      return;
    }

    const model = this.editorsContainerView.getModel();

    // eslint-disable-next-line max-len
    const csvRows = csvUtil.serialize(this.deps.jsdata.Campaign, this.editorsContainerView.campaignEditor.getData());
    // Row at index 2 is not needed and will cause an error
    csvRows.splice(2, 1);

    this.trigger(
      'apply',
      {
        opportunities: [this.data],
        userInputs: [{
          '@odata.type': APPLY_USERINPUT_TYPES[RECOMMENDATION_TYPES.DYNAMIC_SEARCH_ADS],
          OpportunityId: this.data.OpportunityId,
          CampaignName: model.Name,
          Website: model.DomainName,
          WebsiteLanguage: model.LanguageCode,
          Budget: _.isNull(this.data.Target.CampaignId) ? model.Budget.Amount : undefined,
          LocationCsv: _.isNull(this.data.Target.CampaignId) ? csvRows : undefined,
          AdGroupName: model.AdGroupName,
          Bid: model.Bid,
          Text: model.Text,
          TextPart2: model.TextPart2,
          TimeZone: model.TimeZone,
          Path1: model.Path1,
          Path2: model.Path2,
        }],
      }
    );
    const { IsRecommendationInlineErrorEnabled } = this.deps.permissions;

    if (!IsRecommendationInlineErrorEnabled) {
      // scroll to top to see feedbacks
      $('html, body').scrollTop(0);
    }
  }

  closeInlineView(e) {
    e.stopImmediatePropagation();
    this.remove();
    this.trigger('cancel');
  }

  renderEditors(data) {
    const adEditorModel = data.model;

    ko.cleanNode(this.$('.dynamic-search-ads-editor-container')[0]);

    if (this.editorsContainerView && this.editorsContainerView.off) {
      this.editorsContainerView.off('updated');
    }

    this.editorsContainerView = new EditorsContainer({
      deps: this.deps,
      i18n: this.i18n,
      searchExamples: this.data.SearchExamples,
      model: _.extend(adEditorModel, { Type: 'DynamicSearch' }),
      campaignId: this.data.Target.CampaignId,
      adGroupId: this.data.Target.AdGroupId,
    });

    this.$('.dynamic-search-ads-editor-container').html(this.editorsContainerView.render().el);
  }
}
